<template>
  <div class="blur">
    <div class="center">
      <font-awesome-icon icon="fa-solid fa-circle-notch" spin size="6x" color="white" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.blur {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: $black, $alpha: 0.5);
  z-index: 99;

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
</style>
